export default {
  Landing: '/',
  About: '/about',
  Review: '/review',
  Media: '/video',
  Experiments: '/experiments',
  Contacts: '/contacts'
};
